import TableCell from "./TableCell";
import SourceIcons from "./SourceIcons";

const TableRow = ({ item, intervals, showDaily, isAdmin }) => {
  if (!item) return null;

  const getIntervalSourceTooltip = (intervalIndex) => {
    if (!isAdmin || !item.intervalSources?.[intervalIndex]) return null;

    const sources = item.intervalSources[intervalIndex];
    const hasData = Object.values(sources).some((count) => count > 0);

    if (!hasData) return null;

    return <SourceIcons sources={sources} size={25} />;
  };

  const getTotalSourceTooltip = () => {
    if (!isAdmin || !item.responds) return null;

    const sourceCounts = { avito: 0, yandex: 0, vk: 0 };
    item.responds.forEach((respond) => {
      if (respond?.source) {
        const source = respond.source.toLowerCase();
        if (sourceCounts.hasOwnProperty(source)) {
          sourceCounts[source]++;
        }
      }
    });

    const hasData = Object.values(sourceCounts).some((count) => count > 0);
    if (!hasData) return null;

    return <SourceIcons sources={sourceCounts} size={25} />;
  };

  return (
    <tr>
      <TableCell value={item.ink} />
      <TableCell value={item.company} />
      <TableCell value={item.vacancy} />

      <TableCell value={item.manager || "не указан"} />

      {intervals?.map((_, intervalIndex) => {
        const count = item.intervalCounts?.[intervalIndex] || 0;
        const tooltipContent = getIntervalSourceTooltip(intervalIndex);
        return (
          <TableCell
            key={intervalIndex}
            value={count}
            center
            highlight={showDaily && count > 0}
            tooltipContent={isAdmin ? tooltipContent : null}
          />
        );
      })}
      <TableCell
        value={item.respondCount || 0}
        tooltipContent={isAdmin ? getTotalSourceTooltip() : null}
      />
    </tr>
  );
};

export default TableRow;
